


export const DOWNLOADING_TITLE = 'DOWNLOADING_TITLE';
export const PLEASE_WAIT_TITLE = 'PLEASE_WAIT_TITLE';
export const PDF_DOWNLOADING_MESSAGE = 'PDF_DOWNLOADING_MESSAGE';
export const INFORMATION_UPDATE_MESSAGE = 'INFORMATION_UPDATE_MESSAGE';
export const COST_UPDATE_MESSAGE = 'COST_UPDATE_MESSAGE';
export const COST_ADDING_MESSAGE = 'COST_ADDING_MESSAGE';
export const COST_CONFIRMING_MESSAGE = 'COST_CONFIRMING_MESSAGE';
export const COST_AMOUNT_ERROR_MESSAGE = 'COST_AMOUNT_ERROR_MESSAGE';
export const COST_EMPTY_FIELD_ERROR_MESSAGE = 'COST_EMPTY_FIELD_ERROR_MESSAGE';
export const PDF_FILE_NAME = "PDF_FILE_NAME";
export const SWAL_ERROR_TITLE = 'SWAL_ERROR_TITLE';
export const SWAL_SUCCESS_TITLE = 'SWAL_SUCCESS_TITLE';
export const UNKNOWN_ERROR_MESSAGE = 'UNKNOWN_ERROR_MESSAGE';
export const SWAL_TYPE_ERROR = 'error';
export const SWAL_TYPE_SUCCESS = 'success';
export const SWAL_TYPE_INFO = 'info';
export const COST_PHOTO_DELETE_SUCCESS = 'COST_PHOTO_DELETE_SUCCESS';
export const OPERATION_PROCESSING = 'OPERATION_PROCESSING';


export const TR = "tr";
export const EN = "en";
export const COST_DATE_ERROR_MESSAGE = 'COST_DATE_ERROR_MESSAGE';
export const COST_INVOICE_NO_ERROR_MESSAGE = 'COST_INVOICE_NO_ERROR_MESSAGE';
export const COST_TYPE_ERROR_MESSAGE = 'COST_TYPE_ERROR_MESSAGE';
export const COST_MONEY_TYPE_ERROR_MESSAGE = 'COST_MONEY_TYPE_ERROR_MESSAGE';
export const COST_PAYMENT_TYPE_ERROR_MESSAGE = 'COST_PAYMENT_TYPE_ERROR_MESSAGE';
export const COST_BRAND_ERROR_MESSAGE = 'COST_BRAND_ERROR_MESSAGE';
export const COST_DEPARTMENT_ERROR_MESSAGE = 'COST_DEPARTMENT_ERROR_MESSAGE';
export const COST_SUPPLIER_NAME_ERROR_MESSAGE = 'COST_SUPPLIER_NAME_ERROR_MESSAGE';
export const COST_CATEGORY_ERROR_MESSAGE = 'COST_CATEGORY_ERROR_MESSAGE';
export const COST_LOCATION_ERROR_MESSAGE = 'COST_LOCATION_ERROR_MESSAGE';
export const COST_DOCUMENTATION_TYPE_ERROR_MESSAGE='COST_DOCUMENTATION_TYPE_ERROR_MESSAGE';
export const COST_DESCRIPTION_ERROR_MESSAGE = 'COST_DESCRIPTION_ERROR_MESSAGE';
export const COST_KDV_ERROR_MESSAGE = 'COST_KDV_ERROR_MESSAGE'; 
export const COST_PHOTO_ERROR_MESSAGE = "COST_PHOTO_ERROR_MESSAGE";


// SUMIAGRO FORM EMPTY FIELD WARNING MESSAGE
export const COST_COMPANY_NAME_ERROR_MESSAGE =  'COST_COMPANY_NAME_ERROR_MESSAGE';
export const COST_PLACE_NAME_ERROR_MESSAGE =    'COST_PLACE_NAME_ERROR_MESSAGE';
export const COST_GUEST_NAME_ERROR_MESSAGE =    'COST_GUEST_NAME_ERROR_MESSAGE';
export const COST_GUEST_NUMBER_ERROR_MESSAGE =  'COST_GUEST_NUMBER_ERROR_MESSAGE';
export const COST_STAFF_NAME_ERROR_MESSAGE =    'COST_STAFF_NAME_ERROR_MESSAGE';
export const COST_STAFF_NUMBER_ERROR_MESSAGE =  'COST_STAFF_NUMBER_ERROR_MESSAGE';
export const COST_OTHER_PARTICIPANT_ERROR_MESSAGE =     'COST_OTHER_PARTICIPANT_ERROR_MESSAGE';
export const COST_OTHER_PARTICIPANT_NUMBER_ERROR_MESSAGE =  'COST_OTHER_PARTICIPANT_NUMBER_ERROR_MESSAGE';
export const COST_ACTUAL_EXPENDITURE_ERROR_MESSAGE =    'COST_ACTUAL_EXPENDITURE_ERROR_MESSAGE';









